/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 223:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(195);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(191);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(184);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(205);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(135);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(210);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(224);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(142);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(146);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(95);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(226);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(177);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(208);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(209);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(2);
/* harmony import */ var _utils_maps__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(228);
/* harmony import */ var _utils_get_siblings__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(236);
/* harmony import */ var _svg_icon_arrow_left_svg__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(237);





var _window$Shopify, _window$Shopify$theme, _window$Shopify$theme2;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
























/* global google */




var selectors = {
  producersMap: '[data-producers-map]',
  producersList: '[data-producers-list]',
  producersIntro: '[data-producers-intro]',
  locationContent: '[data-location-content]',
  locationBreadcrumbs: '[data-location-breadcrumbs]',
  locationBreadcrumbsList: '.breadcrumbs__list',
  locationBreadcrumbsItem: '[data-location-breadcrumb-item]',
  locationDetails: '[data-location-details]',
  locationButton: '[data-location]',
  producerLocationDetails: '[data-producer-location-details]'
};
var cssClasses = {
  hide: 'hide',
  active: 'active',
  inactive: 'inactive'
};
var sectionType = 'main-page-producers';
var registeredSections = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : (_window$Shopify$theme = _window$Shopify.theme) === null || _window$Shopify$theme === void 0 ? void 0 : (_window$Shopify$theme2 = _window$Shopify$theme.sections) === null || _window$Shopify$theme2 === void 0 ? void 0 : _window$Shopify$theme2.registered) || {};
var isUnregistered = typeof registeredSections[sectionType] === 'undefined';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isUnregistered && (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_26__.register)(sectionType, {
  onLoad: function onLoad() {
    var _this$container$query, _this$container$query2;

    this.producersMap = this.container.querySelector(selectors.producersMap);
    this.producersList = this.container.querySelector(selectors.producersList);
    this.producersIntro = this.container.querySelector(selectors.producersIntro);
    this.locationContent = this.container.querySelector(selectors.locationContent);
    this.locationBreadcrumbs = this.container.querySelector(selectors.locationBreadcrumbs);
    this.locationBreadcrumbsList = this.container.querySelector(selectors.locationBreadcrumbsList);
    this.locationDetails = this.container.querySelector(selectors.locationDetails);

    if (!this.producersMap || !this.producersList || !this.producersIntro || !this.locationContent || !this.locationBreadcrumbs || !this.locationBreadcrumbsList || !this.locationDetails) {
      return;
    }

    this.producerLocationDetails = JSON.parse((_this$container$query = (_this$container$query2 = this.container.querySelector(selectors.producerLocationDetails)) === null || _this$container$query2 === void 0 ? void 0 : _this$container$query2.innerHTML) !== null && _this$container$query !== void 0 ? _this$container$query : '{}');
    this.mapLocations = [];
    this.mapPolygons = [];
    this.initMap();
    this.initList();
  },
  initMap: function initMap() {
    var _window$theme, _window$theme$breakpo;

    var mapOptions = {
      zoom: window.innerWidth < ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : (_window$theme$breakpo = _window$theme.breakpoints) === null || _window$theme$breakpo === void 0 ? void 0 : _window$theme$breakpo.medium) ? 1 : 3,
      center: {
        lat: 6.3,
        lng: 69.5
      },
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      styles: _utils_maps__WEBPACK_IMPORTED_MODULE_27__.styles
    };
    this.map = new google.maps.Map(this.producersMap, mapOptions);
  },
  initList: function initList() {
    this.producersList.addEventListener('click', this.handleLocationButtonClick.bind(this));
    this.locationContent.addEventListener('click', this.handleLocationButtonClick.bind(this));
    var searchParams = new URLSearchParams(window.location.search);
    var location = searchParams.get('location');
    this.setLocation(location);
  },
  handleLocationButtonClick: function handleLocationButtonClick(event) {
    var locationButton = event.target.closest(selectors.locationButton);
    if (!locationButton) return;
    var location = locationButton.dataset.location;
    this.setLocation(location);
  },
  setLocation: function setLocation(location) {
    var _this = this;

    // Remove all active classes from location list items
    var activeListItems = this.producersList.querySelectorAll(".".concat(cssClasses.active));
    activeListItems.forEach(function (activeListItem) {
      return activeListItem.classList.remove(cssClasses.active);
    }); // Remove all inactive classes from location list items

    var inactiveListItems = this.producersList.querySelectorAll(".".concat(cssClasses.inactive));
    inactiveListItems.forEach(function (inactiveListItem) {
      return inactiveListItem.classList.remove(cssClasses.inactive);
    }); // Set top level map locations, this will get overwritten if we find an active location button below

    var mapLocations = Array.from(this.producersList.querySelectorAll(':scope > li > [data-location]')).map(function (childLocation) {
      return childLocation.dataset.location;
    }); // Set new active and inactive classes based on the new location

    var locationButton = this.producersList.querySelector("[data-location=\"".concat(location, "\"]"));

    if (locationButton) {
      var _locationButton$nextE;

      var closestListItem = locationButton.parentElement.closest('li');

      while (closestListItem !== null) {
        closestListItem.classList.add(cssClasses.active);
        var listItemSiblings = (0,_utils_get_siblings__WEBPACK_IMPORTED_MODULE_28__.getSiblings)(closestListItem);
        listItemSiblings.forEach(function (listItemSibling) {
          return listItemSibling.classList.add(cssClasses.inactive);
        });
        closestListItem = closestListItem.parentElement.closest('li');
      }

      mapLocations = locationButton !== null && locationButton !== void 0 && (_locationButton$nextE = locationButton.nextElementSibling) !== null && _locationButton$nextE !== void 0 && _locationButton$nextE.hasAttribute('data-child-location-list') ? Array.from(locationButton.nextElementSibling.querySelectorAll(':scope > li > [data-location]')).map(function (childLocation) {
        return childLocation.dataset.location;
      }) : [location];
    } // Remove all breadcrumbs


    var locationBreadcrumbsItems = this.locationBreadcrumbs.querySelectorAll(selectors.locationBreadcrumbsItem);
    locationBreadcrumbsItems.forEach(function (locationBreadcrumbsItem) {
      return locationBreadcrumbsItem.remove();
    }); // If location is set update location content, else clear details and show producers intro

    if (location) {
      var _this$producerLocatio, _this$producerLocatio2;

      var locationParts = location.split(' > ');
      var currentLocation = locationParts.pop();
      var currentLocationName = currentLocation.split(':').pop().trim();
      var currentLocationDescription = (_this$producerLocatio = (_this$producerLocatio2 = this.producerLocationDetails[currentLocationName]) === null || _this$producerLocatio2 === void 0 ? void 0 : _this$producerLocatio2.description) !== null && _this$producerLocatio !== void 0 ? _this$producerLocatio : '';
      var parentLocation = locationParts.join(' > ');
      this.locationDetails.innerHTML = "\n          <div class=\"location-content__header\">\n            <button class=\"location-content__back\" type=\"button\" data-location=\"".concat(parentLocation, "\">\n              ").concat(_svg_icon_arrow_left_svg__WEBPACK_IMPORTED_MODULE_29__, "\n            </button>\n            <h4 class=\"location-content__heading h-secondary\">").concat(currentLocation, "</h4>\n          </div>\n          ").concat(currentLocationDescription && "\n            <div class=\"location-content__description\">\n              ".concat(currentLocationDescription, "\n            </div>\n            "), "\n        ");
      locationParts.forEach(function (locationPart, index) {
        var fullLocation = locationParts.reduce(function (previous, current, _index) {
          if (_index > index) {
            return previous;
          }

          if (!previous) {
            return current;
          }

          return "".concat(previous, " > ").concat(current);
        }, '');
        var locationPartNoLabel = locationPart.split(':').pop().trim();

        _this.locationBreadcrumbsList.insertAdjacentHTML('beforeend', "<li data-location-breadcrumb-item class=\"breadcrumbs__item\">\n              <button class=\"breadcrumbs__button\" type=\"button\" data-location=\"".concat(fullLocation, "\">\n                ").concat(locationPartNoLabel, "\n              </button>\n            </li>"));
      });
      this.locationBreadcrumbsList.insertAdjacentHTML('beforeend', "<li data-location-breadcrumb-item class=\"breadcrumbs__item\">\n            <span>\n              ".concat(currentLocationName, "\n            </span>\n          </li>"));
      this.producersIntro.classList.add(cssClasses.hide);
      this.locationContent.classList.remove(cssClasses.hide);
    } else {
      this.locationDetails.innerHTML = '';
      this.producersIntro.classList.remove(cssClasses.hide);
      this.locationContent.classList.add(cssClasses.hide);
    } // Setup new map locations


    this.mapLocations = mapLocations.reduce(function (prevLocations, mapLocation, index) {
      var _this$producerLocatio5, _this$producerLocatio6;

      var newLocations = _toConsumableArray(prevLocations);

      var mapLocationParts = mapLocation.split(' > ');
      var currentMapLocation = mapLocationParts.pop();
      var currentMapLocationName = currentMapLocation.split(':').pop().trim(); // Add top level locations in a lighter shade

      if (index === 0) {
        mapLocationParts.forEach(function (mapLocationPart, _index) {
          var _this$producerLocatio3, _this$producerLocatio4;

          var parentMapLocationParts = _toConsumableArray(mapLocationParts);

          parentMapLocationParts.length = _index + 1;
          var parentMapLocationName = mapLocationPart.split(':').pop().trim();
          newLocations = [].concat(_toConsumableArray(newLocations), [{
            includePathsInZoom: false,
            location: parentMapLocationParts.join(' > '),
            coordinates: (_this$producerLocatio3 = (_this$producerLocatio4 = _this.producerLocationDetails[parentMapLocationName]) === null || _this$producerLocatio4 === void 0 ? void 0 : _this$producerLocatio4.coordinates) !== null && _this$producerLocatio3 !== void 0 ? _this$producerLocatio3 : '',
            strokeColor: '#D9D9D9',
            strokeOpacity: 1,
            fillColor: '#F5F5F5',
            fillOpacity: 0.25
          }]);
        });
      }

      return [].concat(_toConsumableArray(newLocations), [{
        includePathsInZoom: true,
        location: mapLocation,
        coordinates: (_this$producerLocatio5 = (_this$producerLocatio6 = _this.producerLocationDetails[currentMapLocationName]) === null || _this$producerLocatio6 === void 0 ? void 0 : _this$producerLocatio6.coordinates) !== null && _this$producerLocatio5 !== void 0 ? _this$producerLocatio5 : '',
        strokeColor: '#BFBFBF',
        strokeOpacity: 1,
        fillColor: '#474D46',
        fillOpacity: 1
      }]);
    }, []); // Clear old polygons from the map

    this.mapPolygons.forEach(function (mapPolygon) {
      mapPolygon.setMap(null);
    });
    this.mapPolygons = []; // Update the map with the new location polygons

    var mapBounds = new google.maps.LatLngBounds();
    this.mapLocations.forEach(function (mapLocation) {
      if (!mapLocation.coordinates) return; // Format the coordinates

      var mapCoordinates = (0,_utils_maps__WEBPACK_IMPORTED_MODULE_27__.buildCoordinatesArrayFromString)(mapLocation.coordinates);
      mapCoordinates.forEach(function (paths) {
        if (mapLocation.includePathsInZoom) {
          paths.forEach(function (path) {
            return mapBounds.extend(path);
          });
        } // Construct the polygon


        var polygon = new google.maps.Polygon({
          paths: paths,
          strokeColor: mapLocation.strokeColor,
          strokeOpacity: mapLocation.strokeOpacity,
          strokeWeight: 1,
          fillColor: mapLocation.fillColor,
          fillOpacity: mapLocation.fillOpacity
        }); // Draw the polygon on the map

        polygon.setMap(_this.map);
        polygon.addListener('click', function () {
          _this.setLocation(mapLocation.location);
        }); // Store this polygon so we can clear it later

        _this.mapPolygons.push(polygon);
      });
    }); // Pan/zoom the map to its new position

    this.map.fitBounds(mapBounds, -50); // Set a min zoom of 3 for desktop

    setTimeout(function () {
      if (window.innerWidth < window.theme.breakpoints.widescreen || _this.map.getZoom() > 2) {
        return;
      }

      _this.map.setZoom(3);
    }, 10); // Update the URL with the new location

    var searchParams = new URLSearchParams(window.location.search);

    if (location) {
      searchParams.set('location', location);
    } else {
      searchParams["delete"]('location');
    }

    var newUrl = "".concat(window.location.pathname).concat(searchParams.toString() && '?'.concat(searchParams.toString()));
    window.history.replaceState({
      path: newUrl
    }, '', newUrl);
  }
}));

/***/ }),

/***/ 236:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getSiblings": () => (/* binding */ getSiblings)
/* harmony export */ });
var getSiblings = function getSiblings(element) {
  var siblings = [];

  if (!element.parentNode) {
    return siblings;
  }

  var sibling = element.parentNode.firstChild;

  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== element) {
      siblings.push(sibling);
    }

    sibling = sibling.nextSibling;
  }

  return siblings;
};

/***/ }),

/***/ 228:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "styles": () => (/* binding */ styles),
/* harmony export */   "buildCoordinatesArrayFromString": () => (/* binding */ buildCoordinatesArrayFromString)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(229);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(210);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(230);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(231);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(195);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(171);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(224);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_parse_float_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(234);
/* harmony import */ var core_js_modules_es_parse_float_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_float_js__WEBPACK_IMPORTED_MODULE_8__);









var styles = [{
  elementType: 'geometry.fill',
  stylers: [{
    color: '#ffffff'
  }]
}, {
  elementType: 'geometry.stroke',
  stylers: [{
    color: '#d9d9d9'
  }]
}, {
  elementType: 'labels',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'road',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'transit',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'water',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#f1ebe6'
  }]
}];
var buildCoordinatesArrayFromString = function buildCoordinatesArrayFromString(geometryCoordinates) {
  // Create groups of data based on each POLYGON definition
  var geometryGroups = geometryCoordinates.split('POLYGON').filter(function (geometryGroup) {
    return geometryGroup.includes('((') && geometryGroup.includes('))');
  });
  return geometryGroups.map(function (geometryGroup) {
    // Remove '((' from the front of the string and '))' from the end
    var start = geometryGroup.indexOf('((') + 2;
    var end = geometryGroup.indexOf('))');
    var cleanCoordinates = geometryGroup.substring(start, end); // Split on ',' so we get an array of coordinate pairs

    var coordinateGroups = cleanCoordinates.split(','); // Return each set of coordinates as an obect with lng and lat properties

    return coordinateGroups.map(function (item) {
      var coordinates = item.trim().split(' ');
      return {
        lng: parseFloat(coordinates[0]),
        lat: parseFloat(coordinates[1])
      };
    });
  });
};

/***/ }),

/***/ 237:
/***/ ((module) => {

module.exports = "<svg aria-label=\"Left arrow icon\" class=\"icon icon-arrow-left\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M19.168 10L0.834633 10\" stroke=\"currentColor\"/>\n<path d=\"M6.3457 15.8332L0.835509 10.0089L6.3457 4.1665\" stroke=\"currentColor\"/>\n</svg>\n";

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			25: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbibendum"] = self["webpackChunkbibendum"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [37], () => (__webpack_require__(223)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;